import { ImportStatusEnum, ImportType } from '@/models/productsImport.model';
import { TFunction } from 'i18next';

export const getImportTypeLabel = (type: ImportType, t: TFunction) => {
  switch (type) {
    case ImportType.PRODUCT:
      return t('imports_list_type_products');
    case ImportType.STOCK:
      return t('imports_list_type_stocks');
    case ImportType.FILTER_VALUE:
      return t('imports_list_filters');
    default:
      return '';
  }
};

export const getImportStatusLabel = (status: ImportStatusEnum, t: TFunction) => {
  switch (status) {
    case ImportStatusEnum.FINISHED:
      return t('imports_list_status_finished');
    case ImportStatusEnum.PROCESSING:
      return t('imports_list_status_processing');
    case ImportStatusEnum.FAILED:
      return t('imports_list_status_failed');
    default:
      return '';
  }
};
